import { message } from 'antd';
import useConversationOps from 'hooks/business/useConversationOps';
import { useTranslate } from '@tolgee/react';
import { useSetReceptionBuyer } from 'hooks/business/receptionBuyerStat';
import { useMakeConversationCache } from 'hooks/business/conversation';

// 关闭会话
export const useConvReceptionClose = () => {
  const { t } = useTranslate();
  const { modifyConversationV2 } = useConversationOps();
  const setConversation = useMakeConversationCache('set');
  const setReceptionBuyer = useSetReceptionBuyer();

  return (conversation: Conversation.Conversation) =>
    modifyConversationV2(
      {
        conversationId: conversation.conversationId,
        process: true,
      },
      () => {
        message.success(t('conversation_closed'));

        // 调用时可保证 conversation 存在于 conversationMap，所以可以只传部分字段
        setConversation({
          conversationId: conversation.conversationId,
          processed: true,
          inReception: false,
        } as any);

        setReceptionBuyer((pre) => {
          return {
            ...pre,
            inReceptionCount: pre.inReceptionCount - 1,
          };
        });
      },
    );
};

// 重启会话
export const useConvReceptionReopen = () => {
  const { t } = useTranslate();
  const { modifyConversationV2 } = useConversationOps();
  const setConversation = useMakeConversationCache('set');
  const setReceptionBuyer = useSetReceptionBuyer();

  return (talk: Conversation.Conversation) =>
    modifyConversationV2(
      {
        conversationId: talk.conversationId,
        reOpen: true,
      },
      () => {
        message.success(t('conversation_reopened'));

        // 调用时可保证 conversation 存在于 conversationMap，所以可以只传部分字段
        setConversation({ conversationId: talk.conversationId, inReception: true } as any);

        setReceptionBuyer((pre) => {
          return {
            ...pre,
            inReceptionCount: pre.inReceptionCount + 1,
          };
        });
      },
    );
};
